module.exports = __webpack_public_path__ + "img/手机背景.d77d01f3.png";